import type { RouteLocationNormalized } from 'vue-router';
import { normalizeScrollPosition } from '@/router/router-scroll.ts';

type ScrollRoute = Pick<RouteLocationNormalized, 'path'>;
type ScrollPosition = { left: number; top: number };
type PrimaryPage = 'events' | 'groups';

function primaryPage(route: ScrollRoute): PrimaryPage | undefined {
  if (route.path.startsWith('/events')) return 'events';
  if (route.path.startsWith('/groups')) return 'groups';
}

export function createPrimaryPageScrollMemory() {
  const positions = new Map<PrimaryPage, ScrollPosition>();

  return {
    remember(route: ScrollRoute, position: ScrollPosition) {
      const page = primaryPage(route);
      if (!page) return;
      positions.set(page, {
        left: Math.max(0, position.left),
        top: Math.max(0, position.top),
      });
    },
    resolve(to: ScrollRoute, from: ScrollRoute, savedPosition: ScrollPosition | null): ScrollPosition | undefined {
      const destination = primaryPage(to);
      if (!destination || destination === primaryPage(from)) return;
      const position = normalizeScrollPosition(savedPosition) ?? positions.get(destination) ?? { left: 0, top: 0 };
      positions.set(destination, position);
      return position;
    },
    position(route: ScrollRoute): ScrollPosition | undefined {
      const page = primaryPage(route);
      return page ? positions.get(page) : undefined;
    },
    clear() {
      positions.clear();
    },
  };
}

export const primaryPageScrollMemory = createPrimaryPageScrollMemory();
